
import React from "react";

import LogsParser from "../component/LogsParser"; 

const LogsParserContainer = () => (<LogsParser />)

export default LogsParserContainer; 